import { connect } from 'react-redux';

import selectors from '../selectors';
import ModalTypes from '../constants/ModalTypes';
import Fixed from '../components/Fixed';

const mapStateToProps = (state) => {
  const { projectId } = selectors.selectPath(state);
  const currentBoard = selectors.selectCurrentBoard(state);
  // FAMILY-EXT: раньше ProjectSettingsModal рендерился внутри Project.jsx
  // (через ProjectContainer), но мы Fixed перевели на прямой BoardsContainer
  // и Project выпал из дерева. Берём флаг сами.
  const currentModal = selectors.selectCurrentModal(state);

  return {
    projectId,
    board: currentBoard,
    isProjectSettingsOpen: currentModal === ModalTypes.PROJECT_SETTINGS,
  };
};

export default connect(mapStateToProps)(Fixed);
